import { GraphQLFieldConfig, GraphQLNonNull, GraphQLID } from 'graphql'
import { jobStatusType } from '../types/job-status'

interface Context {
  readonly connector: {
    readonly get: (url: string) => Promise<any>
  }
}

interface QueryArgs {
  readonly id: string
}

export const jobStatus: GraphQLFieldConfig<undefined, Context, QueryArgs> = {
  type: new GraphQLNonNull(jobStatusType),
  args: {
    id: {
      description: 'The unique ID of the job being queried for',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(_source, { id }, { connector: { get } }) {
    const {
      data: { progress, total }
    } = await get(`/global/progress/${id}`)

    return {
      id,
      progress,
      total
    }
  }
}
